import { LightbulbGroupOffOutlineIcon } from './LightbulbGroupOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 54E68537-16C8-48C4-82F8-4A1000DA605D
 * name lightbulb-group-off-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-group-off-outline.svg
 * tags
 * - Home Automation 
 */
export const BulbGroupOffOutlineIcon = LightbulbGroupOffOutlineIcon;
export default BulbGroupOffOutlineIcon